import script from "./DefaultRoleSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./DefaultRoleSelect.vue?vue&type=script&setup=true&lang=js"

import "./DefaultRoleSelect.vue?vue&type=style&index=0&id=01b5816f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01b5816f"]])

export default __exports__